export const TEAM_DIALOG_SETTINGS = {
  maxHeight: '90vh',
  height: '18.75rem',
  panelClass: 'people-team-dialog',
  // disableClose: true,
};
